// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPost, BASE_URL, retrieveToken } from "../../store/api";
import { UserCreateResponse } from "./types";

import * as userActions from "./user.actions";
import { showModal } from "../modal/modal.actions";

export function* createUser(
  action: ReturnType<typeof userActions.createUserAsync.request>
) {
  try {
    let errors: ErrorResponse = {
      name: '',
      message: '',
      code: 422,
      status: 422,
      data: []
    };

    if (!action.payload.ROLE_ID) {
      errors.data?.push({
        field: "ROLE_ID",
        message: "Peran karyawan wajib diisi"
      })
    }

    if (!action.payload.NIK) {
      errors.data?.push({
        field: "EMP_ID",
        message: "Nama karyawan wajib diisi"
      })
    }

    if (errors.data && errors.data.length > 0) {
      yield put(userActions.createUserAsync.failure(errors));
      return;
    }

    const token: string = yield retrieveToken();
    const url = BASE_URL + 'users';
    const result: Response = yield call(apiPost, url, token, action.payload);

    if (result.status === 201) {
      const parsed: UserCreateResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(userActions.createUserAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userActions.createUserAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Terjadi kesalahan pada server', 'Silahkan coba kembali dalam beberapa saat'));
    yield put(userActions.createUserAsync.failure(parsed));
  }
}

export default function* userSagaCreateUser() {
  yield takeEvery(userActions.createUserAsync.request, createUser);
}
